import React, { Component, PropTypes } from 'react';

import './style.scss';

class Mail extends Component {

  render() {
    return (
      <section className="content-wrapper">
        {this.props.children}
      </section>
    );
  }
}

Mail.propTypes = {
  children: PropTypes.element
};

export default Mail;



/** WEBPACK FOOTER **
 ** ./src/members/Main/Mail/index.js
 **/